import React, { useState, useEffect } from "react";
import { TbBell } from "react-icons/tb";
import { IoSettingsOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IconButton from "./IconButton";
import LeftHeading from "./LeftHeading";
import LogoutConfirmationModal from "./LogoutConfirmationModal";
import Sidebar from "./Sidebar";
import NotificationBar from "./NotificationBar";
import SettingDropdown from "./SettingDropdown";
import { fetchAcademicYear } from "../../Store/Slices/Common/AcademicYear/academicYear.action";
import { staffLogout } from "../../Store/Slices/Common/Auth/actions/staffActions";
import { getAY } from "../../Utils/academivYear";
import { fetchFinancialYear } from "../../Store/Slices/Common/FinancialYear/financialYear.action";
import ChatBot from "./ChatBot";
import { Modal } from "antd";
import { FaArrowRight } from "react-icons/fa";
import { setShowError } from "../../Store/Slices/Common/Alerts/alertsSlice";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
const Navbar = () => {
  const { t } = useTranslation("common");
  const [isOpenNotification, setIsOpenNotification] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [showSetting, setShowSetting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const leftHeading = useSelector(
    (store) => store.common.user.navbar.leftHeading
  );
  const role = useSelector((store) => store.common.auth.role);
  const dispatch = useDispatch();
  const { FinancialYears } = useSelector((store) => store.common.financialYear);
  const selectAcademicYear = useSelector((store) => {
    const say = getAY();
    return store.common.academicYear.academicYears?.find(
      (year) => year?._id == say
    );
  });
  useEffect(() => {
    if (!selectAcademicYear) {
      dispatch(fetchAcademicYear());
    }
    if (FinancialYears?.length < 1) {
      dispatch(fetchFinancialYear());
    }
  }, []);


  useEffect(() => {
    setNotificationCount(localStorage.getItem("NotificationCount"));
  }, []);

  const navigateProfile = () => {
    const routes = {
      parent: "/users/parent/profile",
      admin: "/users/admin",
      student: "/student/profile",
      teacher: "/users/my/profile",
      finance: "/users/my/profile",
      librarian: "/users/my/profile",
      staff: "/users/my/profile",
    };
    navigate(routes[role] || "/");
  };

  const logout = async () => {
    await dispatch(staffLogout());
    setIsModalOpen(false);
  };


  // Inactivity  (5 Minutes)
  const [againLogin, setAgainLogin] = useState(false)

  const inactivityTime = 50 * 60 * 1000;
  let timeoutId;
  function startTimer() {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      Cookies.remove("userToken");
      Cookies.remove("say");
      Cookies.remove("isAcademicYearActive");
      Cookies.remove("schoolId");
      Cookies.remove("SelectedschoolId");
      // Mandatory lines
      dispatch(setShowError(false));

      // Clear local storage and reset Redux states
      localStorage.clear(); // Clear local storage
      setAgainLogin(true);
    }, inactivityTime);
  }

  function resetTimer() {
    startTimer();
  }

  const events = [
    'mousemove',
    'mousedown',
    'keypress',
    'scroll',
    'touchstart'
  ];

  events.forEach(event => {
    window.addEventListener(event, resetTimer);
  });
  startTimer();



  const isSignedIn = useSelector((store) => store.common.auth.isLoggedIn);
  return (
    <div className="sticky top-0 w-full  start-0 end-0 z-20 bg-white border-b shadow-sm">
      <Modal isModalOpen={againLogin} footer={null}
        closable={false} open={againLogin}>
        <h1>{t("You've Been Away")}</h1>
        <p className="text-gray-600">
          {t("Your session was open without any activity for a while, so you need to sign in again. This is to ensure your account is not accessed by someone else.")}
        </p>
        <button className="flex items-center gap-2 flex-row relative justify-center w-full py-2 rounded-md bg-gradient-to-r from-purple-500 to-red-500 text-white text-lg" onClick={() => navigate('/')}>{t("Sign In")} <FaArrowRight size={15} /></button>

      </Modal>
      <div className="flex items-center p-2 py-2.5 bg-white">
        {/* Left Heading */}
        <LeftHeading leftHeading={leftHeading} navigate={navigate} />
        <div className="flex items-center space-x-2 relative justify-center  ">
          {/* <div
            className="border-e px-4 font-semibold text-gradient"
            title="Academic Year"
          >
            {t("AY")}: {selectAcademicYear && selectAcademicYear?.year}
          </div> */}

          {isSignedIn && <ChatBot />}
          {/* Notification Icon with Count 


          {/* Settings Icon */}
          <div>
            <IconButton
              icon={IoSettingsOutline}
              label={t("Settings")}
              onClick={() => setShowSetting(!showSetting)}
              className="hover:bg-gray-200 rounded-full transition-all duration-200"
            />
          </div>

          {/* Dropdown for Settings */}
          <div>
            {" "}
            <SettingDropdown
              showSetting={showSetting}
              setShowSetting={setShowSetting}
              navigateProfile={navigateProfile}
              openModal={() => setIsModalOpen(true)}
            />
          </div>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      <LogoutConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={logout}
      />

      {/* Notification Sidebar */}
      <Sidebar
        isOpen={isOpenNotification}
        onClose={() => setIsOpenNotification(false)}
        title={t("Recent Notifications")}
      >
        <NotificationBar />
      </Sidebar>
    </div>
  );
};

export default Navbar;
